import React, { createContext } from 'react';
import { Offer } from '../domain';

interface OffersContextProps {
  offers: Offer[];
}

const OffersContext = createContext<OffersContextProps>({
  offers: [],
});

export const OffersContextProvider = ({ children, offers }) => (
  <OffersContext.Provider value={offers}>{children}</OffersContext.Provider>
);

export default OffersContext;
